/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ uris: NonNullable<unknown> }} Developer_Redirect_Uris_LabelInputs */



/**
* | output |
* | --- |
* | "Redirect URIs: {uris}" |
*
* @param {Developer_Redirect_Uris_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_redirect_uris_label = /** @type {((inputs: Developer_Redirect_Uris_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Redirect_Uris_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`URI de redirection : ${i?.uris}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`URIs de redirección: ${i?.uris}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`URIs de Redirecionamento: ${i?.uris}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`URI di Reindirizzamento: ${i?.uris}`)
	return /** @type {LocalizedString} */ (`Redirect URIs: ${i?.uris}`)
});